import { render, staticRenderFns } from "./g-base-modal.vue?vue&type=template&id=3a4149a2&scoped=true&"
import script from "./g-base-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-base-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./g-base-modal.vue?vue&type=style&index=0&id=3a4149a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4149a2",
  null
  
)

export default component.exports